import * as React from "react";

interface SVGRProps {
	title?: string;
	titleId?: string;
}
function SvgSplit({
	title,
	titleId,
	...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
	return (
		<svg
			width={24}
			height={24}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			aria-labelledby={titleId}
			{...props}
		>
			{title ? <title id={titleId}>{title}</title> : null}
			<path d="M12 3a1 1 0 0 1 1 1v16a1 1 0 0 1-2 0V4a1 1 0 0 1 1-1ZM5.293 8.293a1 1 0 1 1 1.414 1.414L5.414 11H8.02a1 1 0 0 1 0 2H5.414l1.293 1.293a1 1 0 0 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3Zm12.02 0a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.415-1.414L18.605 13H16a1 1 0 0 1 0-2h2.605l-1.293-1.293a1 1 0 0 1 0-1.414Z" />
		</svg>
	);
}

const MemoSvgSplit = React.memo(SvgSplit);
export default MemoSvgSplit;
